import { render, staticRenderFns } from "./WithDrawBulkOperationDialog.vue?vue&type=template&id=c06d1bde&scoped=true&"
import script from "./WithDrawBulkOperationDialog.vue?vue&type=script&lang=js&"
export * from "./WithDrawBulkOperationDialog.vue?vue&type=script&lang=js&"
import style0 from "./WithDrawBulkOperationDialog.vue?vue&type=style&index=0&id=c06d1bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d1bde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
